module.exports = __webpack_public_path__ + "img/06_food1.98acb615.png";